import * as Yup from 'yup';

const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_\-\.]+\.[a-zA-Z]{2,3}$/;
const PHONE_REGEX = /^0\d{9}$/;
const TOWN_REGEX = /^[a-zA-Z\s-]{1,50}$/;
const POSTCODE_REGEX = /^\d{4}$/;
// Allows letters, numbers, spaces, commas, periods, slashes and hyphens. 5-100 chars
const ADDRESS_REGEX = /^[a-zA-Z0-9\s,'\.\-\/]{5,100}$/;

const parentFormSchema = Yup.object().shape({
    Email1: Yup.string()
        .required('Email should not be blank')
        .test(
            'email1-format',
            'Email format not correct, Please use the correct format',
            (value) => !value || EMAIL_REGEX.test(value)
        ),
    Email2: Yup.string().test(
        'email2-format',
        'Email format not correct, Please use the correct format',
        (value) => !value || EMAIL_REGEX.test(value)
    ),
    Number1: Yup.string()
        .required('Number should not be blank')
        .test(
            'number1-format',
            'Phone Number format not correct, Start with 0 and should be 10 digits',
            (value) => !value || PHONE_REGEX.test(value)
        ),
    Number2: Yup.string().test(
        'number2-format',
        'Phone Number format not correct, Start with 0 and should be 10 digits',
        (value) => !value || PHONE_REGEX.test(value)
    ),
    Town: Yup.string()
        .required('Town Name cannot be empty')
        .test(
            'town-format',
            'Town Name should only contain letters',
            (value) => !value || TOWN_REGEX.test(value)
        ),
    PostCode: Yup.string()
        .required('Post Code cannot be empty')
        .test(
            'postcode-format',
            'Post Code should be 4 digits',
            (value) => !value || POSTCODE_REGEX.test(value)
        ),
    Address1: Yup.string()
        .required('Address cannot be Empty')
        .test(
            'address1-format',
            'Address must be between 5 and 100 characters and should not contain invalid characters',
            (value) => !value || ADDRESS_REGEX.test(value)
        ),
    Address2: Yup.string().test(
        'address2-format',
        'Address must be between 5 and 100 characters and should not contain invalid characters',
        (value) => !value || ADDRESS_REGEX.test(value)
    ),
    Address3: Yup.string().test(
        'address3-format',
        'Address must be between 5 and 100 characters and should not contain invalid characters',
        (value) => !value || ADDRESS_REGEX.test(value)
    ),
    State: Yup.string().required('State is required'),
    accepted: Yup.boolean(),
});

const PERSONAL_FIELDS = new Set(['Email1', 'Email2', 'Number1', 'Number2']);

/** Same rules the Next button uses, so highlighted fields match a blocked step. */
export const getParentContactErrors = (values = {}) => {
    try {
        parentFormSchema.validateSync(values, { abortEarly: false });
        return [];
    } catch (err) {
        const seen = new Set();
        return (err.inner || []).reduce((errors, item) => {
            if (!item.path || item.path === 'accepted' || seen.has(item.path)) return errors;
            seen.add(item.path);
            errors.push({
                field: item.path,
                section: PERSONAL_FIELDS.has(item.path) ? 'personal' : 'address',
                message: item.message,
            });
            return errors;
        }, []);
    }
};

export default parentFormSchema;
